// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "social_post".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { socialPostMediaTypeValues, socialPostStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "social_post" table (1:1 with a DB row, on the wire). */
export const socialPostAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    title: z.string(),
    caption: z.string().nullable(),
    mediaType: z.enum(socialPostMediaTypeValues),
    mediaUrl: z.string(),
    mediaUrls: z.unknown().nullable(),
    thumbnailUrl: z.string().nullable(),
    videoId: z.string().nullable(),
    graphicId: z.string().nullable(),
    platforms: z.unknown(),
    platformSettings: z.unknown().nullable(),
    scheduledAt: z.string().datetime().nullable(),
    publishedAt: z.string().datetime().nullable(),
    status: z.enum(socialPostStatusValues),
    platformResults: z.unknown().nullable(),
    errorMessage: z.string().nullable(),
    createdById: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=socialPost.js.map